(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const resultsContainer = document.querySelector('results-list');
    
    if (resultsContainer) {
      resultsContainer.addEventListener('click', (e) => {
        const tab = e.target.closest('.collection-tab-link');
        if (!tab) return;
        
        e.preventDefault();
        
        const url = tab.dataset.collectionUrl;
        if (!url) return;

        const tabLabel = tab.innerText.trim();

        // Add loading state
        resultsContainer.classList.add('loading');
        
        fetch(url)
          .then(response => response.text())
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newResults = doc.querySelector('results-list');
            
            if (newResults) {
              resultsContainer.innerHTML = newResults.innerHTML;
              
              // Re-apply active class to the correct tab in the new HTML
              const newTabs = resultsContainer.querySelectorAll('.collection-tab-link');
              newTabs.forEach(t => {
                t.classList.remove('active');
                if (t.innerText.trim() === tabLabel) {
                  t.classList.add('active');
                }
              });

              if (window.scrollTo) {
                 const offset = resultsContainer.offsetTop - 100;
                 window.scrollTo({ top: offset, behavior: 'smooth' });
              }
            }
            resultsContainer.classList.remove('loading');
          })
          .catch(error => {
            console.error('Error fetching collection:', error);
            resultsContainer.classList.remove('loading');
          });
      });
    }

    // Existing hash scroll logic
    const currentUrl = new URL(window.location.href);
    if (currentUrl.hash) {
      const card = document.getElementById(currentUrl.hash.slice(1));
      if (card) {
        card.scrollIntoView({ behavior: 'instant' });
      }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
